let app = {

   init() {
      let pagin = document.querySelector('.page-contact')
      if (pagin) {
         let faqs = document.querySelectorAll('h3')
         faqs.forEach((faq) => {
            faq.addEventListener('click', () => {
               $(faq).next().toggle(500)
            })
         })

      }

   },
}

setTimeout(() => {
   app.init()
}, 0)
